import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GoogleMap, MapAdvancedMarker, MapCircle } from '@angular/google-maps';
import { MatMiniFabButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'customer-tracking-map',
  imports: [GoogleMap, MapAdvancedMarker, MapCircle, MatDialogContent, MatDialogClose, MatIcon, MatMiniFabButton],
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapComponent {
  protected data: { currentPosition: google.maps.LatLngLiteral; destination: google.maps.LatLngLiteral } =
    inject(MAT_DIALOG_DATA);
  protected circleOptions: google.maps.CircleOptions = {
    strokeColor: '#e90000',
    fillColor: '#e90000'
  };
  protected options: google.maps.MapOptions = {
    mapId: '756fa072f4c6a725',
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: false,
    zoom: 11
  };
}
